module.exports = __webpack_public_path__ + "static/media/bg_6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg_6.png
// module id = 51
// module chunks = 0